import { GraphQLClient } from "graphql-request"

import { Sdk, getSdk } from "./generated"

let client: Sdk | null = null
let token: { auth: Auth; expires_at: number } | null = null
interface Auth {
    access_token: string
    expires_in: number // seconds
    scope: string
    token_type: "Bearer"
}
async function getToken(): Promise<{ auth: Auth; expires_at: number }> {
    const basicAuth = Buffer.from(`${process.env.CTP_CLIENT_ID}:${process.env.CTP_CLIENT_SECRET}`).toString("base64")
    const scope = process.env.CTP_SCOPES
    const res = await fetch(`${process.env.CTP_AUTH_URL}/oauth/token`, {
        method: "POST",
        headers: {
            Authorization: `Basic ${basicAuth}`,
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `grant_type=client_credentials${scope ? `&scope=${scope}` : ""}`,
    })
    const auth = (await res.json()) as Auth
    const expires_at = new Date().getTime() + (auth.expires_in - 300) * 1000
    return { auth, expires_at }
}
export const createClient = (): Sdk => {
    if (client) return client
    const clientUrl = process.env.CTP_API_URL! + "/" + process.env.CTP_PROJECT_KEY! + "/graphql"

    client = getSdk(new GraphQLClient(clientUrl, {}), async (action) => {
        if (!token || new Date().getTime() > token.expires_at) {
            token = await getToken()
        }
        return action({
            "Content-Type": "application/json",
            Authorization: `${token.auth.token_type} ${token.auth.access_token}`,
        })
    })
    return client
}
